import { render } from "./verticalTouchspin.vue?vue&type=template&id=cbfaeae6"
import script from "./verticalTouchspin.vue?vue&type=script&lang=js"
export * from "./verticalTouchspin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__